// 只决定业务主题和分页体验，不参与菜单授权、角色判断或数据权限。
export function isBusinessComponent(component) {
  if (typeof component !== 'string') return false
  return component === 'index'
    || component === 'executive/inquiry/index'
    || ['pc-operation/', 'kefu/', 'gly/', 'home/', 'system/platform'].some(prefix => component.startsWith(prefix))
}

export function isBusinessRoute(route) {
  const path = route?.path || ''
  return Boolean(route?.meta?.businessView)
    || path === '/executive/inquiries'
    || path === '/direct-inquiry'
    || ['pc-operation', 'kefu', 'gly'].some(prefix => path.startsWith(`/${prefix}/`))
}
